/** @module csi/threeD/paths */
define(["dojo/_base/lang", "underscore", "csi/reflection", "csi/store/Cache", "csi/store/Nodes", "csi/xml", "csi/xml/Query"], function (
	lang,
	_,
	reflection,
	Cache,
	Nodes,
	xml,
	Query
) {
	var _paths = {
		ReviewStyleRevision: [
			"Child:__Parent__/Child:DataSheetSamples/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:SRLineItemSamples/Child:DocumentsAndComments/Child:Documents",
		],
		ApparelBOMRevision: [
			"Child:__Parent__/Child:DataSheetSamples/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:SRLineItemSamples/Child:DocumentsAndComments/Child:Documents",
		],
		DataSheetRevision: [
			"Child:__Parent__/Child:DataSheetSamples/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:SRLineItemSamples/Child:DocumentsAndComments/Child:Documents",
		],
		MaterialBOMRevision: [
			"Child:__Parent__/Child:DataSheetSamples/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:DocumentsAndComments/Child:Documents",
			"Child:__Parent__/Child:__Parent__/Parent:SRLineItemProduct/Child:SRLineItemSamples/Child:DocumentsAndComments/Child:Documents",
		],
	};

	/**
	 * Add path for given type
	 * @param {string} type
	 * @param {string} path
	 */
	function add(type, path) {
		get(type).push(path);
	}

	/**
	 * Remove path for given type
	 * @param {string} type
	 * @param {string} path
	 */
	function remove(type, path) {
		get(type).dele(path);
	}

	/**
	 * Return paths for given type
	 * @param {string} type
	 * @return {string[]}
	 */
	function get(type) {
		var paths = _paths[type];
		if (!paths) {
			var rc = reflection.getClass(type);
			if (rc.isDerivedFrom("DataSheetRevision")) {
				paths = _paths["DataSheetRevision"];
			} else {
				paths = [];
			}

			_paths[type] = paths;
		}

		return paths;
	}

	/**
	 * Return a store of nodes that meet the parameters
	 * @param {Node} node
	 * @param {Cache} [cache]
	 * @return {Nodes}
	 */
	function getNodesStore(node, cache) {
		var paths = get(node.$Type);
		if (!paths.length) {
			return null;
		}

		var requestParameters = {
			"Qry.Limit.Path": _.map(paths, lang.hitch(xml, xml.getUrlPath, node.$URL)),
		};

		var q = new Query()
			.Attr("Is3D", xml.OP_EQUALS, true)
			.Attr("AlternateFiles", xml.OP_NOT_NULL, null, "Child:CurrentRevision")
			.Attr("VariantName", xml.OP_EMPTY_STRING, null);

		return new Nodes({
			cachingStore: cache || new Cache(),
			filterQuery: q,
			sortQuery: new Query().SortByNode(xml.PROP_NAME),
			requestParameters: requestParameters,
			typeNode: "Document",
		});
	}

	return {
		add: add,
		remove: remove,
		get: get,
		getNodesStore: getNodesStore,
	};
});
